import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

export default function iotSliderHybrid() {
  const block = document.querySelector('.slider-hybrid-iot');
  const isReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!block || isReduceMotion) {
    return;
  }

  const heading = block.querySelector('.slider-hybrid-iot__heading');
  const items = block.querySelectorAll('.slider-hybrid-iot__grid-item');
  const tl = gsap.timeline({ paused: true, delay: 0.2 });

  tl.fromTo(
    heading,
    { opacity: 0, yPercent: 100 },
    { opacity: 1, yPercent: 0, ease: 'power2.out', duration: 1 }
  ).fromTo(items, { opacity: 0 }, { opacity: 1, ease: 'power2.out', duration: 1, stagger: 0.3 }, '-=0.5');

  ScrollTrigger.create({
    trigger: block,
    start: () => 'top 90%',
    onLeaveBack: () => {
      tl.reverse();
    },
    onEnter: () => {
      tl.play();
    },
    markers: false
  });

  ScrollTrigger.sort();
}
